export const LOGIN_REDIRECT_PARAM = 'redirect';

/** Builds the landing URL that opens the login modal and remembers the target. */
export const buildLoginUrl = (requestUrl?: string): string => {
  const params = new URLSearchParams({ login: '1' });
  if (requestUrl) {
    const { pathname, search, hash } = new URL(requestUrl);
    const target = `${pathname}${search}${hash}`;
    if (isSafeRedirectTarget(target) && pathname !== '/') {
      params.set(LOGIN_REDIRECT_PARAM, target);
    }
  }
  return `/?${params.toString()}`;
};

/** Only same-origin, absolute in-app paths are allowed (prevents open redirects). */
export const isSafeRedirectTarget = (
  target: string | null | undefined,
): target is string =>
  !!target &&
  target.startsWith('/') &&
  !target.startsWith('//') &&
  !target.includes('\\');
